// extracted by mini-css-extract-plugin
export default {"processed-invoices":"ProcessedInvoices_processed-invoices__eFgWl","toolbar__button--show-rejected":"ProcessedInvoices_toolbar__button--show-rejected__uhszr"};